import { useState } from 'react';
import { string } from 'prop-types';
import './Avatar.css';

const Avatar = ({ image = null }) => {
  const [isImageFailing, setIsImageFailing] = useState(false);

  return (
    <div className="avatar">
      {image && !isImageFailing ? (
        <img src={image} alt="Avatar" onError={() => setIsImageFailing(true)} />
      ) : (
        <i className="fas fa-user-circle menu" />
      )}
    </div>
  );
};

Avatar.propTypes = {
  image: string,
};

export default Avatar;
